import React from 'react'

import {
  getLiveId,
  getPresenterToken,
} from '../../../../../global/blocs/roomInfo'
import { getLiveToken } from '../../../../../global/blocs/useConnectInfo'
import QuestionsPane from '../../../../../sharedLegacy/features/WebinarSidebarFeature/components/QuestionsPane/QuestionsPane'

import './FocusQuestions.scss'

const FocusQuestions = () => {
  return (
    <div className="focus-questions-pane">
      <QuestionsPane
        commonCommentsProps={{
          canDelete: false,
          liveId: getLiveId(),
          presenterToken: getPresenterToken(),
          token: getLiveToken(),
        }}
        unreadQuestionsIdList={[]}
      />
    </div>
  )
}

export { FocusQuestions }
